/** @jsx jsx */

import { jsx, Divider, Text, Image, Flex } from 'theme-ui'
import SocialButton from '../../../images/SocialButton.svg'
import openInNewTab from '../../../utils/openInNewTab'

export default function SocialMediaButton() {
  return (
    <div
      data-automation-id="social-media-button"
      tabIndex={0}
      role="button"
      onClick={event => {
        event.stopPropagation()
        let url =
          'https://studiotoolkit.dmplocal.com/sites/2926/dailysocialmedia.html'
        openInNewTab(url)
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          let url =
            'https://studiotoolkit.dmplocal.com/sites/2926/dailysocialmedia.html'
          openInNewTab(url)
        }
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
        paddingLeft: '0',
        paddingRight: '0',
        paddingTop: '1px',
        cursor: 'pointer',
        outline: 'none',
      }}
    >
      <Divider
        sx={{
          width: '100%',
          color: '#979491',
          borderBottom: '1px solid',
          paddingTop: '0',
          marginTop: '10px',
          marginBottom: '16px',
        }}
      />
      <Text
        variant="xxSmallText"
        sx={{
          mb: '8px',
          boxSizing: 'border-box',
          margin: 0,
          minWidth: 0,
          fontFamily:
            'Graphik system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          width: '100%',
          color: 'black',
          textAlign: 'left',
        }}
      >
        Engage with Your Followers Daily
      </Text>
      <Flex
        sx={{
          display: 'inline-flex',
          width: 'auto',
          minWidth: 0,
          border: 0,
          backgroundColor: 'transparent',
          paddingY: 0,
          paddingX: 0,
          fontSize: '14px',
          fontWeight: 500,
          alignItems: 'center',
          color: 'black',
          mt: '11px',
          boxShadow: 'none',
          '&:hover': {
            cursor: 'pointer',
          },
          svg: {
            marginRight: '12px',
          },
        }}
      >
        <Image
          src={SocialButton}
          alt="SocialMedia Logo"
          data-automation-id="social-media-image"
          sx={{
            maxWidth: '100%',
            height: 'auto',
            mr: 2,
            transition: 'box-shadow 0.2s',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '2px 2px 4px 0 #6F6C69',
              cursor: 'pointer',
            },
          }}
        />
      </Flex>
    </div>
  )
}
